import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const PRODUCTS = [{
  name: 'Velvet Louis Chair',
  category: 'Furniture',
  image: 'https://images.unsplash.com/photo-1517705008128-361805f42e86?q=80&w=1987&auto=format&fit=crop',
  price: 'From $15.00'
}, {
  name: 'Gold Rimmed Charger',
  category: 'Table-top',
  image: 'https://images.unsplash.com/photo-1510076857177-7470076d4098?q=80&w=2072&auto=format&fit=crop',
  price: 'From $4.50'
}, {
  name: 'Crystal Candelabra',
  category: 'Lighting',
  image: 'https://cdn.magicpatterns.com/uploads/5cuEJQcVp11df44fUMfuW2/pexels-rachel-claire-5864480.jpg',
  price: 'From $25.00'
}, {
  name: 'Linen Table Runner',
  category: 'Textiles',
  image: 'https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?q=80&w=2012&auto=format&fit=crop',
  price: 'From $12.00'
}, {
  name: 'Modern Bar Stool',
  category: 'Bar & Lounge',
  image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?q=80&w=2070&auto=format&fit=crop',
  price: 'From $18.00'
}, {
  name: 'Vintage Lounge Sofa',
  category: 'Furniture',
  image: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=2070&auto=format&fit=crop',
  price: 'From $85.00'
}];
// Duplicate products for seamless loop
const INFINITE_PRODUCTS = [...PRODUCTS, ...PRODUCTS, ...PRODUCTS];
export function RentalSlider() {
  return <section className="py-8 bg-[#121212] overflow-hidden border-y border-white/5" data-id="element-137">
      <div className="mx-[4.1rem]" data-id="element-138">
        <div className="max-w-[1440px] mx-auto px-6 mb-8" data-id="element-139">
          <div className="flex flex-col md:flex-row justify-between items-end gap-6" data-id="element-140">
            <div className="max-w-2xl" data-id="element-141">
              <h2 className="font-serif text-xl md:text-2xl text-white leading-tight mb-2" data-id="element-142">
                New in the rental / <br data-id="element-143" />
                <span className="italic text-[#b22222]" data-id="element-144">
                  rental range & our favourites
                </span>
              </h2>
              <p className="text-gray-400 text-xs leading-relaxed" data-id="element-145">
                Discover the latest trends and favourite products from our event
                rental shop.
              </p>
            </div>
            <button className="text-[9px] font-bold uppercase tracking-widest text-white hover:text-[#b22222] transition-colors border-b border-white/20 pb-1" data-id="element-146">
              View All Products
            </button>
          </div>
        </div>

        {/* Infinite Scroll Container */}
        <div className="relative flex overflow-hidden" data-id="element-147">
          <motion.div className="flex gap-6" animate={{
          x: [0, -1836] // Width of one set of products (6 * (280 + 24))
        }} transition={{
          duration: 30,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-148">
            {INFINITE_PRODUCTS.map((product, index) => <div key={index} className="flex-none w-[240px] md:w-[280px] group cursor-pointer" onClick={() => window.location.href = '#rental'} data-id="element-149">
                <div className="relative h-[180px] overflow-hidden mb-3 bg-[#1a1a1a] shadow-xl border border-white/5" data-id="element-150">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-90 group-hover:opacity-100" data-id="element-151" />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition-colors duration-300" data-id="element-152" />

                  <div className="absolute bottom-0 left-0 w-full p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-153">
                    <button className="w-full bg-white text-black py-2 text-[8px] font-bold uppercase tracking-widest flex items-center justify-center gap-2 hover:bg-[#b22222] hover:text-white transition-colors" data-id="element-154">
                      <ShoppingBag size={10} data-id="element-155" /> Rent Now
                    </button>
                  </div>

                  <div className="absolute top-2 left-2 bg-[#b22222] text-white px-2 py-0.5 text-[7px] font-bold uppercase tracking-widest" data-id="element-156">
                    New
                  </div>
                </div>

                <div className="text-center" data-id="element-157">
                  <p className="text-[8px] uppercase tracking-[0.2em] text-gray-500 mb-0.5" data-id="element-158">
                    {product.category}
                  </p>
                  <h3 className="text-sm font-serif text-white group-hover:text-[#b22222] transition-colors mb-0.5" data-id="element-159">
                    {product.name}
                  </h3>
                  <p className="text-[10px] font-medium text-gray-400" data-id="element-160">
                    {product.price}
                  </p>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}